import { Component, signal, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { UsersService } from '../../shared/services/users/users.service';
import { AzureAuthService } from '../../shared/services/auth/AuthAzureService';
import { LoginService } from '../../shared/services/login/login.service';
import { LoaderComponent } from '../../shared/components/loader/loader.component';
import { LoaderService } from '../../shared/services/loader/loader.service';
import { StorageService } from '../../shared/services/storage/storage.service';
import { AuthTokenService } from '../../shared/services/auth-token.service';
import { RolesService } from '../../shared/services/roles/roles.service';
import { MenuRefreshService } from '../../shared/services/menu/menu-refresh.service';
import { MatDialog } from '@angular/material/dialog';
import { NoAccessDialogComponent } from '../../shared/components/no-access-dialog/no-access-dialog.component';
import { TokenExpirationService } from '../../shared/services/token-expiration/token-expiration.service';
import { SessionTimeoutService } from '../../shared/services/session/session-timeout.service';
import { environment } from 'src/environments/environment';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    LoaderComponent,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css', '../../shared/styles/layout.css'], // Usa styleUrls (en plural) si hay varios archivos
})
export class LoginComponent {
  // Injected services
  private readonly destroyRef = inject(DestroyRef);
  private readonly _snackBar = inject(MatSnackBar);
  private readonly dialog = inject(MatDialog);
  private readonly userService = inject(UsersService);
  private readonly router = inject(Router);
  private readonly azureAuthService = inject(AzureAuthService);
  private readonly loginService = inject(LoginService);
  private readonly loaderService = inject(LoaderService);
  private readonly storageService = inject(StorageService);
  private readonly authTokenService = inject(AuthTokenService);
  private readonly rolesService = inject(RolesService);
  private readonly menuRefreshService = inject(MenuRefreshService);
  private readonly tokenExpirationService = inject(TokenExpirationService);
  private readonly sessionTimeoutService = inject(SessionTimeoutService);

  currentEnvironment = environment;
  version: string = '';
  environment: 'Local' | 'Dev' | '' = 'Local';

  token = signal<string | null>(null);
  profile = signal<string | null>(null);

  // OTP login properties
  username: string = '';
  password: string = '';
  code: string = '';
  isSubmitted: boolean = false;
  errorMessage: string = '';
  mail: string = '';
  doTheMagic: boolean = false;

  constructor() {
    // this.azureAuthService.getTokenSubject().subscribe({
    //   next: (token: string | null) => {
    //     this.token.set(token);
    //     console.log('Token received:', token);
    //     if (token != null) {
    //       const payload = this.azureAuthService.decodeJWTPayload(token);
    //       console.log('Decoded JWT Payload:', payload);
    //       if (payload) {
    //         const email = payload.unique_name || '---';
    //         this.profile.set(email);
    //       }
    //     }
    //   },
    //   error: (error) => {
    //     console.error('Error receiving token:', error);
    //   },
    // });
  }

  get isLoading() {
    return this.loaderService.getLoader();
  }

  // Función para mostrar un snackbar
  openSnackBar(message: string) {
    this._snackBar.open(message, 'Cerrar', {
      duration: 5000,
    });
  }

  hide = signal(true);
  clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  userLogin: string = '';
  userPassword: string = '';

  ngOnInit() {
    this.version = this.currentEnvironment.version;
    if (this.currentEnvironment.local) {
      this.environment = 'Local';
    } else if (this.currentEnvironment.development) {
      this.environment = 'Dev';
    } else {
      this.environment = '';
    }
    // console.log('Iniciando componente de login');
    // Check if user is already logged in
    // this.azureAuthService.getAccessToken().subscribe({
    //   next: (accessToken: string | null) => {
    //     console.log('Access token received:', accessToken);
    //   },
    //   error: (error) => {
    //     console.error('Error getting access token:', error);
    //   },
    // });
    // console.log('Usuario ya logueado (localStorage)');
    //this.router.navigate(['/home/dining/general']);
  }

  loginAzure() {
    // console.log('Iniciando autenticación de Azure');
    this.azureAuthService
      .login()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.token.set(response.accessToken);
          // console.log('Login de Azure success', response);
          if (response.accessToken) {
            const tokenPayload = this.azureAuthService.decodeJWTPayload(
              response.accessToken
            );
            // console.log('Token Payload:', tokenPayload);
            if (tokenPayload) {
              const email = tokenPayload.email;
              this.profile.set(email);
            }
          }
        },
        error: (error) => {
          // console.log('Error login with Azure', error);
          this.openSnackBar('Error en el inicio de sesión con Azure.');
        },
      });
  }

  logoutAzure() {
    this.azureAuthService
      .logout()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          // console.log("S'ha tancat la sessió correctament");
        },
        error: (error) => {
          console.error('Error al cerrar sesión en Azure:', error);
          this.openSnackBar('Error al cerrar sesión en Azure.');
        },
      });
  }

  byPassOTP()
  {
    if(!environment.production){
        this.doTheMagic =  !this.doTheMagic;
    }      
  }

  //Login con OTP
  loginOtp() {
    if (this.username && this.password) {
      this.loaderService.showLoader();
      this.loginService
        .loginCheck(this.username, this.password, this.doTheMagic)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (response) => {
            // console.log('Login check successful:', response);
             if (response?.platinium === true) {              
              // console.log('Platinum user detected. Skipping OTP validation.');
              this.handlePlatiniumLogin(response);
              return;
            }

            this.isSubmitted = true;
            this.code = '';
            this.errorMessage = '';
            this.loaderService.hideLoader();
            this.sendOtpAfterCheck(this.doTheMagic);
          },
          error: (error) => {
            console.error('Error during login check:', error);
            if (error.status === 401) {
              this.errorMessage = 'Usuario o contraseña incorrectos';
            } else if (error.status === 400) {
              this.errorMessage =
                'Datos inválidos. Por favor revise sus credenciales';
            } else if (error.status === 500) {
              this.errorMessage = 'Error del servidor. Inténtelo más tarde';
            } else if (error.status === 404) {
              this.errorMessage =
                'Usuario no encontrado. Por favor, inténtelo de nuevo';
            } else {
              this.errorMessage =
                'Error de conexión. Por favor, inténtelo de nuevo';
            }
            this.loaderService.hideLoader();
          },
        });
    } else {
      console.error('Username and password are required for OTP login');
      this.errorMessage = 'Por favor, ingrese usuario y contraseña';
    }
  }

  sendOtpAfterCheck(DoTheMagic: boolean) {
    this.loginService
      .sendOtp(this.username, this.password, DoTheMagic)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          // console.log('OTP sent successfully:', response);

          // Check if user is a platinum user (bypass OTP)
          if (response?.platinium === true) {
            // console.log('Platinum user detected. Skipping OTP validation.');
            this.handlePlatiniumLogin(response);
            return;
          }

          // Regular flow: show OTP input form
          this.isSubmitted = true;
          this.code = '';
          this.errorMessage = '';
          this.loaderService.hideLoader();
        },
        error: (error) => {
          console.error('Error sending OTP:', error);
          if (error.status === 500) {
            this.errorMessage =
              'Error del servidor al enviar el código. Inténtelo más tarde';
          } else {
            this.errorMessage =
              'Error al enviar el código. Por favor, inténtelo de nuevo.';
          }
          this.loaderService.hideLoader();
        },
      });
  }

  validateOtp() {
    if (this.username && this.code) {
      this.loaderService.showLoader();
      this.loginService
        .validateOtp(this.username, this.code)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (response) => {
            // console.log('OTP validation successful:', response);

            // Save the user profile (without serveto_user_roles)
            this.storageService.setItem(
              this.userService.USER_PROFILE_KEY,
              response
            );

            this.errorMessage = '';
            this.mail = response.email || '';

            if (response && response.token) {
              this.authTokenService.setToken({ access_token: response.token });
              // Token expiration disabled - only using inactivity timeout
              // this.tokenExpirationService.updateTokenDate();
              this.sessionTimeoutService.startMonitoring();

              // Load user roles and sidemenu in parallel
              this.loadUserDataAndRedirect(response.external_id);
            } else {
              this.errorMessage = 'Usuario no autorizado';
              this.loaderService.hideLoader();
            }
          },
          error: (error) => {
            console.error('Error during OTP validation:', error);
            // Handle error during OTP validation
            if (error.status === 401) {
              this.errorMessage = 'Código incorrecto o expirado';
            } else if (error.status === 400) {
              this.errorMessage = 'Código inválido';
            } else if (error.status === 500) {
              this.errorMessage = 'Error del servidor. Inténtelo más tarde';
            } else {
              this.errorMessage =
                'Error de conexión. Por favor, inténtelo de nuevo';
            }
            this.loaderService.hideLoader();
          },
        });
    } else {
      console.error('Username and code are required for OTP validation');
      this.errorMessage = 'Por favor, ingrese su código de verificación';
    }
  }

  /**
   * Loads user roles and sidemenu data, then redirects to appropriate page
   * @param externalId User's external ID
   */
  loadUserDataAndRedirect(externalId: string) {
    // Load both user roles and sidemenu data
    const rolesRequest = this.rolesService.getEmployeeRoles(externalId);
    const menuRequest = this.rolesService.getUserSidemenu(externalId);

    // Execute both requests in parallel using forkJoin
    forkJoin({
      roles: rolesRequest,
      menuData: menuRequest,
    })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ roles, menuData }) => {
          // console.log('User roles loaded successfully:', roles);
          // console.log('User sidemenu loaded successfully:', menuData);

          // Save roles data
          this.storageService.setItem('user_roles', roles);

          // Save sidemenu data
          this.storageService.setItem('user_sidemenu', menuData);

          // console.log('User data saved to local storage');

          this.menuRefreshService.triggerMenuRefresh();

          this.checkPermissionsAndRedirect(menuData);
          this.loaderService.hideLoader();
        },
        error: (error) => {
          console.error('Error loading user data:', error);
          this.errorMessage = 'Error al cargar los datos del usuario';
          this.loaderService.hideLoader();
        },
      });
  }

  /**
   * Checks user permissions and redirects to the appropriate page.
   * Priority: Comedor > Comunicación > Cultura empresarial > Usuarios
   * If no permissions, shows error message.
   */
  checkPermissionsAndRedirect(menuData?: any[]) {
    // If no menuData provided, try to get it from storage
    if (!menuData) {
      menuData = this.storageService.getItem<any[]>('user_sidemenu') || [];
    }

    if (!menuData || menuData.length === 0) {
      this.openDialog();
      this.storageService.clear();
      return;
    }

    // Priority order (only if present): dining_room > communication > company_culture > users > payrolls > vacations > utilities
    const priorityOrder = [
      'dining_room',
      'communication',
      'company_culture',
      'users',
      'payrolls',
      'vacations',
      'utilities',
    ];

    for (const identifier of priorityOrder) {
      const parent = menuData.find((m: any) => m.identifier === identifier);
      if (parent) {
        this.redirectToMenuItem(parent);
        return;
      }
    }

    // Fallback: first menu item
    if (menuData.length > 0) {
      this.redirectToMenuItem(menuData[0]);
      return;
    }

    this.openDialog();
  }

  /** Resolve a route path from an identifier (parent or child). */
  private resolveRouteFromIdentifier(identifier: string): string | null {
    const routeMap: Record<string, string> = {
      // Parent fallbacks (only used when no children are present)
      users: '/home/users/policies',
      company_culture: '/home/culture/stories',
      communication: '/home/communication/mailbox', // will be overridden by actual child if only one present
      dining_room: '/home/dining/general',
      payrolls: '/home/payroll/manage',
      vacations: '/home/vacations/drivers',
      utilities: '/home/utils',
      // Children
      policies: '/home/users/policies',
      users_list: '/home/users/list',
      stories: '/home/culture/stories',
      mission_vision: '/home/culture/mission',
      organizational_chart: '/home/culture/organization',
      inbox: '/home/communication/mailbox',
      incorporations: '/home/communication/incorporation',
      activities: '/home/communication/activities',
      news: '/home/communication/news',
      general: '/home/dining/general',
      prices: '/home/dining/prices',
      kitchen_screen: '/home/dining/cook-screen',
      kitchenbreakfast_screen: '/home/dining/cookbreakfast-screen',
      drivers: '/home/vacations/drivers',
      management: '/home/vacations/management',
      protocols: '/home/vacations/protocols',
      priority_periods: '/home/vacations/priority-periods',
    };
    return routeMap[identifier] || null;
  }

  /**
   * Redirects to the first accessible child if present; otherwise to the parent route.
   * Ensures we never navigate to a functionality the user does not actually have (e.g. mailbox if not provided).
   */
  private redirectToMenuItem(menuItem: any) {
    // If there are children, pick the first child explicitly returned by backend
    if (Array.isArray(menuItem.children) && menuItem.children.length > 0) {
      for (const child of menuItem.children) {
        const childRoute = this.resolveRouteFromIdentifier(child.identifier);
        if (childRoute) {
          this.router.navigate([childRoute]);
          return;
        }
      }
    }

    // No children (or no mapped child route) -> try parent route
    const parentRoute = this.resolveRouteFromIdentifier(menuItem.identifier);
    if (parentRoute) {
      this.router.navigate([parentRoute]);
      return;
    }

    // Absolute fallback
    this.openDialog();
  }

  goBack() {
    this.isSubmitted = false;
    this.errorMessage = '';
  }

  /**
   * Handles platinum user login flow - bypasses OTP validation
   * @param response Response from sendOtp containing user data
   */
  handlePlatiniumLogin(response: any) {
    try {
      // Save the user profile
      this.storageService.setItem(this.userService.USER_PROFILE_KEY, response);

      this.errorMessage = '';
      this.mail = response.email || '';

      if (response && response.token) {
        // Set authentication token
        this.authTokenService.setToken({ access_token: response.token });
        // Token expiration disabled - only using inactivity timeout
        // this.tokenExpirationService.updateTokenDate();
        this.sessionTimeoutService.startMonitoring();

        // Load user roles and sidemenu, then redirect
        this.loadUserDataAndRedirect(response.external_id);
      } else {
        this.errorMessage = 'Error: Token no disponible';
        this.loaderService.hideLoader();
      }
    } catch (error) {
      console.error('Error handling platinum user login:', error);
      this.errorMessage = 'Error al procesar el inicio de sesión';
      this.loaderService.hideLoader();
    }
  }

  openDialog() {
    this.dialog.open(NoAccessDialogComponent, {
      width: '550px',
      data: {
        title: 'Acceso denegado',
        message: 'No tienes permisos suficientes para acceder.',
        confirmText: 'Cerrar',
        cancelText: 'Cancelar',
      },
    });
  }
}
